export const unauthorizedRouters = {
  path: '/unauthorized',
  name: 'unauthorized',
  component: () => import('@/views/errors/401'),
  meta: {
    noAuth: true
  }
}
